import request from "@/plugins/request"

// 获取列表订单
export const getOrderList = (params) => {
  return request({
    url: "app-api/trade/order/page",
    method: "get",
    params: params,
  })
}

// 获取订单详情
export const getOrderDetail = (params) => {
  return request({
    url: "app-api/trade/order/get-detail",
    method: "get",
    params,
  })
}
